import React, { useState } from "react"
import PropTypes from "prop-types"
import { useDispatch } from "react-redux"
import { useTranslation } from "react-i18next"
import { Alert, Button } from "antd"
import { fetchWidgetCart, resumeWidgetCartHolds } from "store/experiences"

// "Your reservation timer expired, but we've saved your cart…" with "Check availability & continue":
// the only way the cart's items are reserved again (never on opening the cart, never automatically).
// Each item comes back held, or lost with the reason (shown on the item). The cart is read first:
// right after an order expired its items may still read "booked" here until the API says "expired".
// `onChecked(isAllHeld)` follows; a failure shows here.
const ReservationExpiredNotice = ({ onChecked, className }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [isChecking, setIsChecking] = useState(false)
  const [hasFailed, setHasFailed] = useState(false)

  const checkAvailability = async () => {
    setIsChecking(true)
    setHasFailed(false)
    try {
      await dispatch(fetchWidgetCart())
      const isAllHeld = await dispatch(resumeWidgetCartHolds())
      setIsChecking(false)
      onChecked(isAllHeld)
    } catch (error) {
      setIsChecking(false)
      setHasFailed(true)
    }
  }

  return (
    <Alert
      type="warning"
      showIcon
      className={className}
      message={t("booking_widget.hold.expired_text")}
      description={hasFailed ? t("booking_widget.checkout.errors.generic") : null}
      action={
        <Button size="small" loading={isChecking} onClick={checkAvailability}>
          {t("booking_widget.hold.check_availability")}
        </Button>
      }
    />
  )
}

ReservationExpiredNotice.propTypes = {
  onChecked: PropTypes.func,
  className: PropTypes.string
}

ReservationExpiredNotice.defaultProps = {
  onChecked: () => {},
  className: undefined
}

export default ReservationExpiredNotice
